import axios from "axios";

const API_URL = process.env.REACT_APP_API_CORS;

// เดิมหน้า EvaluateForm / EditEvaluateForm บันทึกพฤติกรรม (form2) และการพัฒนา (form4)
// ด้วยการ loop ยิง POST/PUT ทีละแถว ซึ่งทำให้เกิดปัญหา
//   1) หลายจุดใช้ .map(async ...) โดยไม่ await -> ยิงพร้อมกันแล้วปล่อยลอย ลำดับสลับ/ค้างหลังเปลี่ยนหน้า
//   2) step_active คำนวณจาก version ฝั่ง client -> ได้ค่าซ้ำหรือค่าเก่า ทำให้ข้อมูลเวอร์ชันใหม่ไม่ถูกอ่านขึ้นมา
//   3) กดซ้ำ/ยิงซ้ำ -> ได้แถวซ้ำใน step เดียวกัน
// จึงเปลี่ยนมาใช้ endpoint /array/save แบบเดียวกับ evaluateSalaryResult
// ซึ่ง server จะเป็นคนกำหนด step_active (max เดิม + 1) และบันทึกทั้งชุดในคำขอเดียว
const postArray = async (url, payload, token) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: API_URL + url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(payload),
  };

  const response = await axios.request(config);
  return response?.data ?? {};
};

const toNullable = value =>
  value === "" || value === undefined || value === null ? null : value;

/**
 * บันทึกคะแนนพฤติกรรม (form2) ทั้งชุดในคำขอเดียว
 * rows: แถวจาก formTwoData (ต้องมี no ตาม template และ score)
 */
export const saveBehaviorArray = async (
  { evaluate_salary_id, user_id, budget_year, round, rows },
  token
) => {
  const behaviorArray = (rows ?? [])
    // ต้องมี no เสมอเพราะเป็นเลขหัวข้อสมรรถนะที่ผูกกับ template ห้าม renumber
    .filter(row => row?.no !== null && row?.no !== undefined && row?.no !== "")
    .map(row => ({
      no: Number(row.no),
      score: toNullable(row.score),
    }));

  if (behaviorArray.length === 0) return { status: true, skipped: true, results: [] };

  return await postArray(
    "/api/evaluateSalaryBehavior/array/save",
    { evaluate_salary_id, user_id, budget_year, round, behaviorArray },
    token
  );
};

/**
 * บันทึกแผนพัฒนา (form4) ทั้งชุดในคำขอเดียว
 * rows: แถวจาก formFourData (ใช้ id เป็นเลขลำดับช่อง, topic = development_type_id, description = development)
 */
export const saveDevelopmentArray = async (
  { evaluate_salary_id, user_id, budget_year, round, rows },
  token
) => {
  const developmentArray = (rows ?? [])
    // ต้องมี no เสมอเพราะเป็นเลขลำดับช่องในฟอร์ม ห้าม renumber
    .filter(row => row?.id !== null && row?.id !== undefined && row?.id !== "")
    .map(row => ({
      no: Number(row.id),
      development_type_id: toNullable(row.topic),
      development: toNullable(row.description),
    }));

  if (developmentArray.length === 0) return { status: true, skipped: true, results: [] };

  return await postArray(
    "/api/evaluateSalaryDevelopment/array/save",
    { evaluate_salary_id, user_id, budget_year, round, developmentArray },
    token
  );
};
